/**
 * 六彩视界 · UI 语义工具
 * ---------------------------------------------------------------------------
 * 配合 assets/scss/theme.scss 的语义类使用，让模板里的写法统一且可读。
 *
 * 用法（main.js 已挂到 Vue.prototype，模板中直接用 $cls.xxx）：
 *   <span :class="$cls.pill('ok')">正常</span>
 *   <a :class="$cls.link(true)" @click="edit">修改</a>
 *   <span :class="$cls.text('danger')">-320.00</span>
 */

/** 状态语义 → pill 样式后缀 */
const PILL_MAP = {
	// 通用状态
	ok: "ok", success: "ok", 正常: "ok", 已完成: "ok", 已支付: "ok", 成功: "ok",
	enabled: "ok", 启用: "ok",

	warn: "warn", warning: "warn", 余额不足: "warn", 待对账: "warn", 待付款: "warn",
	pending: "warn", 待处理: "warn", 待接单: "warn", 加工中: "warn", 待发货: "warn",
	partial: "warn",

	dan: "dan", danger: "dan", error: "dan", 欠款: "dan", 已退款: "dan",
	cancel: "dan", 已取消: "dan", 退款: "dan", 失败: "dan", 冻结: "dan",

	info: "info", 储值卡: "info", 计次卡: "info", 折扣卡: "info", 进行中: "info",

	gray: "gray", 草稿: "gray", 未开始: "gray", 已归档: "gray", closed: "gray"
};

/** 文本语义 → 文字色类 */
const TEXT_MAP = {
	primary: "lcsj-text-primary",
	success: "lcsj-text-success",
	warning: "lcsj-text-warning",
	danger: "lcsj-text-danger",
	muted: "lcsj-text-muted"
};

export const pill = (status) => {
	const key = status === null || status === undefined ? "" : String(status).trim();
	const suffix = PILL_MAP[key] || PILL_MAP[key.toLowerCase()] || "gray";
	return `lcsj-pill lcsj-pill--${suffix}`;
};

export const text = (semantic) => TEXT_MAP[semantic] || "";

export const link = (isDanger) => (isDanger ? "lcsj-link lcsj-link--danger" : "lcsj-link");

export const card = () => "lcsj-card";

export const summaryRow = () => "lcsj-summary-row";

/**
 * 表格行内操作区：统一替代 3~5 个彩色 mini 按钮
 * @param {Array} 形如 [{ label:"充值", onClick, danger:true, disabled:true }]
 */
export const rowActions = (actions = []) => "lcsj-row-actions";

/**
 * 格式化金额：负数自动取绝对值 + 保留 2 位，配合 pill 展示
 * @param {number} n
 * @param {object} opt { sign:true 显示 +/-, decimals:2, prefix:"¥" }
 */
export function formatMoney(n, opt = {}) {
	const v = Number(n);
	if (!isFinite(v)) return "-";
	const { sign = false, decimals = 2, prefix = "" } = opt;
	const abs = Math.abs(v).toFixed(decimals);
	const s = sign ? (v > 0 ? "+" : v < 0 ? "-" : "") : v < 0 ? "-" : "";
	return prefix + s + abs;
}

/**
 * 金额语义类：负数走 danger 色（沿用项目 money-negative 约定的语义）
 */
export function moneyClass(n) {
	return Number(n) < 0 ? "lcsj-text-danger" : "";
}

const cls = { pill, text, link, card, summaryRow, rowActions, formatMoney, moneyClass };

export default cls;